import React from "react";

import Placar from "./Placar";

export default function Principal() {
  return (
    <div>
      <Placar/>
    </div>
  );
}